import { render, staticRenderFns } from "./TeambotTour.vue?vue&type=template&id=3cb8c1fe&scoped=true&"
import script from "./TeambotTour.vue?vue&type=script&lang=ts&"
export * from "./TeambotTour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8c1fe",
  null
  
)

export default component.exports